import Login from "pages/auth/login";
import DashboardAdvertisement from "pages/dashboard/advertisement";
import DashboardAddProduct from "pages/dashboard/brands";
import DashboardFaqs from "pages/dashboard/faqs";
import DashboardFlaggedUsers from "pages/dashboard/flaggedUsers";
import DashboardHome from "pages/dashboard/home";
import DashboardImages from "pages/dashboard/images";
import DashboardPolicy from "pages/dashboard/policy";
import PowerSellerRequests from "pages/dashboard/powerSellerRequests";
import ProductReports from "pages/dashboard/productReports";
import DashboardProducts from "pages/dashboard/products";
import DashboardSettings from "pages/dashboard/settings";
import SupportMessages from "pages/dashboard/support";
import DashboardTestimonials from "pages/dashboard/testimonials";
import FeatureTransactions from "pages/dashboard/transactions/feature";
import PaymentTransactions from "pages/dashboard/transactions/payments";
import SubscriptionTransactions from "pages/dashboard/transactions/subscription";
import UserReports from "pages/dashboard/userReports";
import DashboardUsers from "pages/dashboard/users";
import Blogs from "pages/dashboard/blogs";
import { routeConstant } from "./routeConstant";

const publicRoute: any = [
  {
    path: routeConstant.login.path,
    title: routeConstant.login.title,
    Component: Login,
  },
];

const privateRoute: any = [
  {
    path: routeConstant.dashboard.path,
    title: routeConstant.dashboard.title,
    Component: DashboardHome,
  },
  {
    path: routeConstant.blogs.path,
    title: routeConstant.blogs.title,
    Component: Blogs,
  },
  {
    path: routeConstant.images.path,
    title: routeConstant.images.title,
    Component: DashboardImages,
  },
  {
    path: routeConstant.advertisement.path,
    title: routeConstant.advertisement.title,
    Component: DashboardAdvertisement,
  },
  {
    path: routeConstant.faqs.path,
    title: routeConstant.faqs.title,
    Component: DashboardFaqs,
  },
  {
    path: routeConstant.policy.path,
    title: routeConstant.policy.title,
    Component: DashboardPolicy,
  },
  {
    path: routeConstant.testimonials.path,
    title: routeConstant.testimonials.title,
    Component: DashboardTestimonials,
  },
  {
    path: routeConstant.brands.path,
    title: routeConstant.brands.title,
    Component: DashboardAddProduct,
  },
  {
    path: routeConstant.settings.path,
    title: routeConstant.settings.title,
    Component: DashboardSettings,
  },
  {
    path: routeConstant.users.path,
    title: routeConstant.users.title,
    Component: DashboardUsers,
  },
  {
    path: routeConstant.powerSellerRequests.path,
    title: routeConstant.powerSellerRequests.title,
    Component: PowerSellerRequests,
  },
  {
    path: routeConstant.paymentTransactions.path,
    title: routeConstant.paymentTransactions.title,
    Component: PaymentTransactions,
  },
  {
    path: routeConstant.subcriptionTransactions.path,
    title: routeConstant.subcriptionTransactions.title,
    Component: SubscriptionTransactions,
  },
  {
    path: routeConstant.featureTransactions.path,
    title: routeConstant.featureTransactions.title,
    Component: FeatureTransactions,
  },
  {
    path: routeConstant.supportMessages.path,
    title: routeConstant.supportMessages.title,
    Component: SupportMessages,
  },
  {
    path: routeConstant.products.path,
    title: routeConstant.products.title,
    Component: DashboardProducts,
  },
  {
    path: routeConstant.userReport.path,
    title: routeConstant.userReport.title,
    Component: UserReports,
  },
  {
    path: routeConstant.productReport.path,
    title: routeConstant.productReport.title,
    Component: ProductReports,
  },
  {
    path: routeConstant.flaggedUsers.path,
    title: routeConstant.flaggedUsers.title,
    Component: DashboardFlaggedUsers,
  },
];

export { privateRoute, publicRoute };
